import { J2Add } from '@e3dc-react/icons'
import { Button } from '@mui/material'
import React from 'react'

interface Props {
  onClick: () => void
}

/**
 * Button to create a new custom chart
 */
const CreateCustomChartButton: React.FC<Props> = ({ onClick }) => {
  return (
    <Button
      variant={'contained'}
      sx={{ width: '36px', height: '36px', minWidth: 'unset', minHeight: 'unset', borderRadius: 1, p: '6px 12px' }}
      onClick={onClick}
    >
      <J2Add />
    </Button>
  )
}

export default CreateCustomChartButton
